import { render } from "./RPanel.vue?vue&type=template&id=4116c53f"
import script from "./RPanel.vue?vue&type=script&lang=js"
export * from "./RPanel.vue?vue&type=script&lang=js"

import "./RPanel.vue?vue&type=style&index=0&id=4116c53f&lang=css"
script.render = render

export default script